import { useState, useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import * as api from 'api/methods';

import { getLessons } from 'store/lessons/actions';
import { removeLessonById } from 'store/lesson/actions';

import { useModal } from 'hooks/useModal';

export const useLessons = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [
    removeConfirmOpen,
    openRemoveConfirm,
    closeRemoveConfirm,
    removeConfirmData,
  ] = useModal({
    defaultOpen: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const _getItems = async () => {
      try {
        await dispatch(getLessons({})).unwrap();
      } catch (error) {
        console.warn(error);
      }

      setLoading(false);
    };

    _getItems();
  }, []);

  const handleLessonRowClick = (lessonId: string) => {
    navigate(`/lessons/${lessonId}`);
  };

  const handleLessonEditClick = (lesson: any) => {
    navigate(`/lessons/${lesson.id}`);
  };

  const handleLessonRemoveClick = (item: any) => {
    openRemoveConfirm({
      title: 'Do you really want to remove lesson?',
      text: '',
      data: {
        item,
      },
    });
  };

  const handleConfirmRemoveClick = ({ item }: { item: any }) => {
    closeRemoveConfirm();

    dispatch(removeLessonById(item.id));
  };

  const handleLessonCreateClick = async () => {
    try {
      const defaultData = {
        title: `Lesson ${uuid()}`,
        courseId: null as any,
        moduleId: null as any,
        role: 'CATALOG',
        order: 1,
      };

      const lesson = await api.createFigmaLesson(defaultData);

      navigate(`/lessons/${lesson.id}`);
    } catch (error) {
      console.warn(error); // TODO: catch error
    }
  };

  return {
    loading,
    removeConfirmOpen,
    removeConfirmData,
    closeRemoveConfirm,
    onLessonRowClick: handleLessonRowClick,
    onLessonEditClick: handleLessonEditClick,
    onLessonRemoveClick: handleLessonRemoveClick,
    onConfirmRemoveClick: handleConfirmRemoveClick,
    onLessonCreateClick: handleLessonCreateClick,
  };
};
